import accessAuth from "./AuthControl"
import accessDashboard from "./DashboardControl"
import accessMaster from "./MasterControl"
import accessUsers from "./UsersControl"
import accessSettings from "./SettingsControl"
import accessMaintenance from "./MaintenanceControl"
import accessInventory from "./InventoryControl"
import accessDoc from "./DocControl"
import accessReport from "./ReportControl"

const RoutesMap = {
    ...accessAuth,
    ...accessDashboard,
    ...accessMaster,
    ...accessSettings,
    ...accessUsers,
    ...accessMaintenance,
    ...accessInventory,
    ...accessDoc,
    ...accessReport,
}

export default RoutesMap;